import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useOnClickOutside } from '../../../hook/useOnClickOutside';
import style from './style.module.scss';

const Select = ({ options, name, reset }) => {
    const [select, setSelect] = useState(null);
    const [open, setOpen] = useState(false);
    const ref = useRef();

    useOnClickOutside(ref, () => setOpen(false));

    useEffect(() => {
        if (reset) {
            setSelect(null);
        }
    }, [reset]);

    return (
        <div ref={ref} className={style.block}>
            <div className={style.select} onClick={() => setOpen(!open)}>
                <div className={style.current}>{select ?? 'Choisir'}</div>

                <div className={style.arrowContainer}>
                    <ArrowBackIosRoundedIcon className={clsx(style.svg, open && style.revertArrow)} />
                </div>
            </div>

            <div className={open ? style.open : style.hide}>
                {options.map((elem, i) => (
                    <div
                        key={elem}
                        className={clsx(style.options, select === elem && style.hideOptions)}
                        onClick={() => {
                            setSelect(elem);
                            setOpen(false);
                        }}
                    >
                        {elem}
                    </div>
                ))}
            </div>

            <input required type="text" name={name} value={select ?? ''} onChange={() => {}} />
        </div>
    );
};

export default Select;
